import { createSlice } from '@reduxjs/toolkit';

import {
    DELETE_USER,
    DELETE_USER_FAILURE,
    DELETE_USER_SUCCESS,
    DOWNLOAD_CSV,
    DOWNLOAD_CSV_FAILURE,
    DOWNLOAD_CSV_SUCCESS,
    FETCH_ROLES,
    FETCH_ROLES_FAILURE,
    FETCH_ROLES_SUCCESS,
    FETCH_TEMPORAL_PASSWORD,
    FETCH_TEMPORAL_PASSWORD_FAILURE,
    FETCH_TEMPORAL_PASSWORD_SUCCESS,
    FETCH_USER_DETAIL,
    FETCH_USER_DETAIL_FAILURE,
    FETCH_USER_DETAIL_SUCCESS,
    FETCH_USERS,
    FETCH_USERS_FAILURE,
    FETCH_USERS_SUCCESS,
    INITIALIZE_FORM,
    OPEN_MODAL_USER,
    RESET,
    RESET_FORM,
    SAVE,
    SAVE_FAILURE,
    SAVE_SUCCESS,
    SET_FILTERS,
} from './actionTypes';
import { NAME } from './constants';

const INITIAL_STATE = {
    deleteUser: {
        data: [],
        error: null,
        isDeleting: false,
    },
    downloadCSV: {
        data: null,
        errors: [],
        isFetching: false,
    },
    fetchRoles: {
        data: [],
        error: null,
        isFetching: false,
    },
    filters: {
        id: '',
        orderBy: '',
        page: 1,
        searchStr: '',
        sortBy: '',
    },
    initialValues: {
        allow_staff_support: false,
        birth_date: '',
        company_group: '',
        company_id: '',
        email: '',
        first_name: '',
        has_tmp_password: false,
        id: null,
        is_enabled: true,
        isOwner: false,
        last_name: '',
        owner_type: '',
        phone: '',
        position: '',
        second_surname: '',
        tmp_password: '',
        type: '',
    },
    isOpenModalUser: false,
    randomPassword: {
        data: null,
        errors: [],
        isFetching: false,
    },
    save: {
        data: {},
        errors: null,
        isSaving: false,
    },
    userDetail: {
        data: null,
        errors: [],
        isFetching: false,
    },
    users: {
        data: {
            data: [],
            paginaton: {},
        },
        error: null,
        isFetching: false,
    },
};

const companyUsersSlice = createSlice({
    name: NAME,
    initialState: INITIAL_STATE,
    reducers: {
        [DELETE_USER]: (state) => {
            state.deleteUser = {
                ...state.deleteUser,
                errors: [],
                isDeleting: true,
            };
        },
        [DELETE_USER_FAILURE]: (state, action) => {
            state.deleteUser = {
                ...state.deleteUser,
                errors: action.payload,
                isDeleting: false,
            };
        },
        [DELETE_USER_SUCCESS]: (state, action) => {
            state.deleteUser = {
                ...state.deleteUser,
                data: action.payload,
                isDeleting: false,
            };
        },
        [DOWNLOAD_CSV]: (state) => {
            state.downloadCSV = {
                ...state.downloadCSV,
                errors: [],
                isFetching: true,
            };
        },
        [DOWNLOAD_CSV_FAILURE]: (state, action) => {
            state.downloadCSV = {
                ...state.downloadCSV,
                errors: action.payload,
                isFetching: false,
            };
        },
        [DOWNLOAD_CSV_SUCCESS]: (state, action) => {
            state.downloadCSV = {
                ...state.downloadCSV,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ROLES]: (state) => {
            state.fetchRoles = {
                ...state.fetchRoles,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_ROLES_FAILURE]: (state, action) => {
            state.fetchRoles = {
                ...state.fetchRoles,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_ROLES_SUCCESS]: (state, action) => {
            state.fetchRoles = {
                ...state.fetchRoles,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_USERS]: (state) => {
            state.users = {
                ...state.users,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_USERS_FAILURE]: (state, action) => {
            state.users = {
                ...state.users,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_USERS_SUCCESS]: (state, action) => {
            state.users = {
                ...state.users,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_USER_DETAIL]: (state) => {
            state.userDetail = {
                ...state.userDetail,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_USER_DETAIL_FAILURE]: (state, action) => {
            state.userDetail = {
                ...state.userDetail,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_USER_DETAIL_SUCCESS]: (state, action) => {
            state.userDetail = {
                ...state.userDetail,
                data: action.payload,
                isFetching: false,
            };
        },
        [FETCH_TEMPORAL_PASSWORD]: (state) => {
            state.randomPassword = {
                ...state.randomPassword,
                errors: [],
                isFetching: true,
            };
        },
        [FETCH_TEMPORAL_PASSWORD_FAILURE]: (state, action) => {
            state.randomPassword = {
                ...state.randomPassword,
                errors: action.payload,
                isFetching: false,
            };
        },
        [FETCH_TEMPORAL_PASSWORD_SUCCESS]: (state) => {
            state.randomPassword.isFetching = false;
        },
        [INITIALIZE_FORM]: (state, action) => {
            state.initialValues = { ...state.initialValues, ...action.payload };
        },
        [OPEN_MODAL_USER]: (state, action) => {
            state.isOpenModalUser = action.payload;
        },
        [RESET]: () => INITIAL_STATE,
        [RESET_FORM]: (state) => {
            state.initialValues = INITIAL_STATE.initialValues;
        },
        [SAVE]: (state) => {
            state.save = { ...state.save, errors: [], isSaving: true };
        },
        [SAVE_FAILURE]: (state, action) => {
            state.save = {
                ...state.save,
                errors: action.payload,
                isSaving: false,
            };
        },
        [SAVE_SUCCESS]: (state, action) => {
            state.save = {
                ...state.save,
                data: action.payload,
                isSaving: false,
            };
        },
        [SET_FILTERS]: (state, action) => {
            state.filters = action.payload;
        },
    },
});

export const companyUsersActions = companyUsersSlice.actions;

export default companyUsersSlice.reducer;
